import { oc } from "@orpc/contract";
import { z } from "zod";

export const arStatementDefaultsContracts = {
  get: oc
    .input(z.object({ customerId: z.string().uuid() }))
    // Recipients only. There is deliberately no stored per-user send default
    // here: "BCC me" is a per-send opt-in, send-from defaults to the current
    // user's mailbox, and the record-copy BCC comes from the AR module config's
    // `outboxBccEmails` — all resolved client-side in the compose dialog.
    .output(z.object({ defaultRecipientEmails: z.array(z.string()) }))
    .route({
      method: "GET",
      summary: "Get default statement recipients for a customer",
    }),
} as const;
